export default __webpack_public_path__ + "images/error-robot-f04374480516551e0d52b2c61ab9ceae.png";